import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'apnst-formly-wrapper-panel',
  templateUrl: './formly-wrapper-panel.component.html',
  styleUrls: ['./formly-wrapper-panel.component.scss'],
})
export class FormlyWrapperPanelComponent extends FieldWrapper {}
